import { DateTime } from 'luxon';

import { NEW_SEMANTIC_ANALYSIS_MIN_DATE } from ':modules/semantic-analysis/constants';

export const isDateAfterNewSemanticAnalysisMinDate = (date: Date): boolean => {
    const dateWithoutTime = DateTime.fromJSDate(date).startOf('day');
    const newSemanticAnalysisMinDateWithoutTime = DateTime.fromJSDate(NEW_SEMANTIC_ANALYSIS_MIN_DATE).startOf('day');
    return dateWithoutTime >= newSemanticAnalysisMinDateWithoutTime;
};
